import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_DMODELS = "magazines";
const BASE_URL = "/api/magazines";

const MagazinesQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const MAGAZINE_EMPTY = {
    title: "",
    description: "",
    date: "",
    file: {},

};

export function useMagazines() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_DMODELS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...MagazinesQueryConfig
    });
    return {...result, magazines: result.data};
}


export function useMagazine(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_DMODELS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...MagazinesQueryConfig
    });
    return {...result, magazine: result.data};
}

export function useMagazineMutations() {
    async function createFunction(magazine) {
        if (!magazine) return;
        return await fetchPOST(BASE_URL, magazine, false);
    }

    async function editRelation(magazine) {
        if (!magazine) return;
        return await fetchPUT(`${BASE_URL}/${magazine.id}/setmagazineheading`, magazine.timeMagazineHeaderId)
    }

    async function editFunction(magazine) {
        if (!magazine) return;
        return await fetchPUT(`${BASE_URL}/${magazine.id}`, magazine);
    }

    async function editAddNewFiles(magazine) {
        if (!magazine) return;
        return await fetchPUT(`${BASE_URL}/${magazine.id}/files`, magazine.fileId);
    }

    async function deleteFunction(magazine) {
        return await fetchDELETE(`${BASE_URL}/${magazine.id}`)
    }

    return {
        createMagazine: useMyMutation(createFunction, REACT_QUERY_ID_DMODELS, magazine => `Magazine ${magazine.title} created`),
        editMagazine: useMyMutation(editFunction, REACT_QUERY_ID_DMODELS, magazine => `Magazine ${magazine.title} modified`),
        editRelation: useMyMutation(editRelation, REACT_QUERY_ID_DMODELS, magazine => `Magazine ${magazine.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_DMODELS, magazine => `Magazine ${magazine.title} modified`),
        deleteMagazine: useMyMutation(deleteFunction, REACT_QUERY_ID_DMODELS, magazine => `Magazine ${magazine.title} deleted.`)
    };

}